<template>
  <SecondaryPane :title="title" :loading="externalLoading" :externaltrigger="dialogtrigger"
    :externalCloseTrigger="dialogclosetrigger" class="pickerpane"
    styleoverride="background-color: white; height: inherit; overflow-y: auto;">

    <template v-if="!isPhoneBool" v-slot:header>
      <slot name="header" />
    </template>

    <template v-slot:content>
      <div v-if="preview"
        style="position: absolute; top: 0; left: 0; z-index: 1000; width: 100%; height: 100%; background-color: white;">
        <slot name="preview" :item="previewItem" :closePreview="closePreview">
          v-slot:preview
        </slot>
      </div>

      <div v-if="hasOverlay"
        style="position: absolute; top: 0; left: 0; z-index: 1001; width: 100%; height: 100%; background-color: white;">
        <slot name="overlay" />
      </div>

      <SelectableListPane :getListMethod="getListMethod" :locked-filters="lockedFilters" :optional-filters="filters"
        :paginationEnabled="paginationEnabled" :show-filter-tab="true" :show-sorting-tab="false"
        :hideCheckboxesOnItems="hideCheckboxesOnItems" :groupBy="groupBy" :groupSort="groupSort"
        :groupItemSort="groupItemSort" :itemsPerPage="itemsPerPage" :multiple="multiple" :itemValueKey="itemValueKey"
        :allowSelectAll="allowSelectAll" :previewable="previewable" :selectText="selectText"
        :createNewFunction="createNewFunction" :alternateSelectActions="alternateSelectActions"
        :preSelected="preSelected" :quickClickFunction="(item) => handleQuickClick(item)"
        :scrollcheckTrigger="scrollcheckTrigger" :onMiddleClick="onMiddleClick" :pk="pk" ref="listpane"
        :eventualDataType="eventualDataType"
        @select="handleSelect" @openPreview="openPreview" @closePreview="closePreview">

        <template v-slot:list-header>
          <v-card class="rounded-0 px-3 py-3" flat>
            <v-row no-gutters>
              <v-col cols="1">
                <v-btn v-if="closeable" icon small @click="close()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="10">
                <h2 class="text-center">{{ title }}</h2>
              </v-col>
              <v-col cols="1" class="d-flex align-center justify-end">
                <v-btn v-if="createNewFunction" outlined color="success" class="pl-1 pr-2" style="min-width: unset;"
                  small @click="createNewFunction()">
                  <v-icon size="18">mdi-plus</v-icon>
                  {{ $t('servicesystem.common_objects.commonterms.new') }}
                </v-btn>
              </v-col>
            </v-row>

            <v-row no-gutters class="mt-3">
              <FilterSearch :pk="pk" :limitWidth="false" class="mx-1" />
            </v-row>

            <slot name="visible-filters">
            </slot>
          </v-card>
        </template>

        <template v-slot:group-header="{ group, items, selectionFilter, setSelectionFilter }">
          <slot name="group-header" :group="group" :items="items" :selectionFilter="selectionFilter"
            :setSelectionFilter="setSelectionFilter">
          </slot>
        </template>

        <template
          v-slot:list-item-wrapper="{ item, index, handleadded, handlechanged, previewable, isPreviewed, showCheckbox, isChecked, 
            toggleCheckbox, openPreview, closePreview, handleItemClick, handleMiddleClick, selectionFilter, setSelectionFilter}">
          <slot name="list-item-wrapper" :index="index" :item="item" :handleadded="handleadded"
            :handlechanged="handlechanged" :previewable="previewable" :isPreviewed="isPreviewed"
            :showCheckbox="showCheckbox" :isChecked="isChecked" :toggleCheckbox="toggleCheckbox"
            :openPreview="openPreview" :closePreview="closePreview" :handleItemClick="handleItemClick"
            :handleMiddleClick="handleMiddleClick" :selectionFilter="selectionFilter"
            :setSelectionFilter="setSelectionFilter">
            <template v-slot:list-item>
              <slot name="list-item" :item="item" :handleadded="handleadded" :handlechanged="handlechanged">
              </slot>
            </template>
          </slot>
        </template>

        <!-- list item template when not overriding wrapper -->
        <template v-slot:list-item="{ item, handleadded, handlechanged }">
          <slot name="list-item" :item="item" :handleadded="handleadded" :handlechanged="handlechanged">
          </slot>
        </template>

        <template
          v-slot:select-actions="{ selectionFilter, filter, selectMethod, clearSelectionMethod, refreshListMethod }">
          <slot name="select-actions" :selectionFilter="selectionFilter" :filter="filter" :selectMethod="selectMethod"
            :clearSelectionMethod="clearSelectionMethod" :refreshListMethod="refreshListMethod">
          </slot>
        </template>

      </SelectableListPane>

    </template>

  </SecondaryPane>
</template>


<script>
import SelectableListPane from "@/views/pim/articles/SelectableListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import FilterSearch from "@/views/layouts/FilterSearch.vue";
import SecondaryPane from './SecondaryPane.vue';

export default {
  name: "PickerPane",
  props: {
    pk: {
      type: String,
      default: "pipa"
    },
    title: {
      type: String,
      default: "PickerPane"
    },
    loading: Boolean,
    getListMethod: {
      type: Function,
      required: true
    },
    paginationEnabled: Boolean,
    itemsPerPage: Number,
    externalLoading: Boolean,
    multiple: Boolean,
    allowSelectAll: Boolean,
    hideCheckboxesOnItems: Boolean,
    preSelected: Array,
    itemValueKey: {
      type: String,
      default: "Id"
    },
    lockedFilters: Object,
    previewable: Boolean,
    closeable: {
      type: Boolean,
      default: true
    },
    selectText: String,
    alternateSelectActions: Array,
    createNewFunction: Function,
    quickClickFunction: Function,
    onMiddleClick: Function,
    groupBy: [Function, String],
    groupSort: Function,
    groupItemSort: Function,
    scrollcheckTrigger: Number,
    closeFunc: Function,
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    /** When set (e.g. 'Article' or 'Customer'), enables eventual data merge from SignalR. */
    eventualDataType: String,
  },
  components: {
    SelectableListPane,
    FilterSearch,
    SecondaryPane,
  },
  mixins: [FilterQueryMixin],

  data() {
    return {
      preview: false,
      previewItem: null
    };
  },

  methods: {
    refreshList() {
      this.$refs.listpane.refreshList();
    },

    async handleQuickClick(item) {
      if (this.quickClickFunction !== undefined) {
        await this.quickClickFunction(item);
        if (this.closeOnSelect) {
          this.close();
        }
      }
      else {
        var selectionFilter = {
          AllSelected: false,
          PrependItemIdList: [item[this.itemValueKey]],
          InitialListFilter: { ...this.filters, ...this.lockedFilters },
        };
        this.handleSelect(selectionFilter);
      }
    },

    openPreview(item) {
      this.previewItem = item;
      this.preview = true;
    },
    closePreview() {
      this.$refs.listpane.setPreviewIndex(null);
      this.preview = false;
    },

    close() {
      if (this.closeFunc !== undefined) {
        this.closeFunc();
      }
      else {
        this.$router.replace({ params: this.$route.params, query: { ...this.$route.query, picker: undefined } });
      }
    },

    clearSelection() {
      this.$refs.listpane.clearAllSelection();
    },

    handleSelect(selectionFilter) {
      this.$emit("select", selectionFilter);
      if (this.closeable && this.closeOnSelect) {
        this.close();
      }
    },
  },

  computed: {
    filters() {
      var filters = {
        ExcludeItemIdList: this.preSelected?.map(x => x[this.itemValueKey]),
        PopulateStoreItems: true,
      };
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes("filter-"))) {
        filters.SearchWord = this.getQueryParam("filter-keyword", undefined);
      }
      return filters;
    },

    dialogtrigger() {
      return this.$store.state.triggerevents.previewTrigger;
    },

    dialogclosetrigger() {
      return this.$store.state.triggerevents.previewCloseTrigger;
    },

    hasOverlay() {
      return !!this.$slots["overlay"];
    },
  },

  watch: {},
};
</script>


<style scoped>
.pickerpane {
  height: 100%;
  z-index: 20;
  border-left: 2px solid #e4e4e4;
  /*border-top: 1px solid grey;*/
  /*border-top-left-radius: 8px;*/
}

/*
.pickerpane::before {
  content: "";
  position: absolute;
  z-index: 21;
  top: 0;
  margin-left: -5px;
  width: 3px;
  height: 100%;
  background-color: red;
}
*/
</style>